export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6561.1fd08328.jpg";